import { gql } from '@apollo/client'
import EducationFragment from './Education.fragment'
import ContractEmployeeLevel from './ContractEmployeeLevel.fragment'
import BusinessUnitFragment from './BusinessUnit.fragment'
import BankAccountFragment from './BankAccount.fragment'
import EmployeeAddressFragment from './EmployeeAddress.fragment'
import EmergencyContactsFragment from './EmergencyContacts.fragment'
import CitizenshipFragment from './Citizenship.fragment'
import employeeSkillStatusFragment from '../../skill-status/employeeSkillStatus.fragment'
export default gql`
  fragment PersonalProfile on PersonalProfile {
    employeeId
    employmentStatus
    legalFirstName
    legalLastName
    email
    username
    chosenLastName
    chosenFirstName
    dateOfBirth
    avatarUrl
    academicTitle
    privateEmailAddress
    replyEntryDate
    skillCenterUrl
    branchOfficeCode
    citizenships {
      ...Citizenship
    }
    currentContractLevel {
      ...ContractEmployeeLevel
    }
    bankAccount {
      ...BankAccount
    }
    address {
      ...EmployeeAddress
    }
    education {
      ...Education
    }
    emergencyContacts {
      ...EmergencyContact
    }
    businessUnit {
      ...BusinessUnitAndComapnyName
    }
    skillStatus {
      ...SkillStatusFragment
    }
    activityListEnabled
  }
  ${BusinessUnitFragment}
  ${EducationFragment}
  ${ContractEmployeeLevel}
  ${BankAccountFragment}
  ${EmployeeAddressFragment}
  ${CitizenshipFragment}
  ${EmergencyContactsFragment}
  ${employeeSkillStatusFragment}
`
